import { ButtonProps, Flex, Text } from '@chakra-ui/react';
import { memo } from 'react';

import FilterPillPopover from '@components/common/FilterPillPopover';
import { CalendarIcon } from 'vectors';

const CalendarPickerPillButtonContent = ({ width }: { width?: ButtonProps['width'] }) => {
  return (
    <Text color="text.secondary" fontWeight="semibold" width={width}>
      Last day
    </Text>
  );
};

interface Props {
  title?: string | React.ReactNode;
  width?: ButtonProps['width'];
}
const CalendarPickerPill = ({ title, width }: Props) => {
  return (
    <Flex flexDir="column" gap={1} align="start">
      {typeof title === 'string' ? (
        <Text fontSize="sm" fontWeight="light">
          {title}
        </Text>
      ) : (
        title
      )}
      <FilterPillPopover
        isActive={false}
        leftIcon={<CalendarIcon boxSize={4} color="text.secondary" />}
        rightIcon={<Flex />}
        buttonContent={<CalendarPickerPillButtonContent width={width} />}
        positioning={{ placement: 'bottom-end' }}
      >
        TODO
      </FilterPillPopover>
    </Flex>
  );
};

export default memo(CalendarPickerPill);
